import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import { getDateFormat } from "../../utils/date-format";
import { usePermissions } from "../../hooks/usePermissions";
import { useState } from "react";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import DropdownMenu from "../../Monolith-UI/DropdownMenu/DropdownMenu.js";
import { EditIcon, TrashIcon } from "lucide-react";
import {
  DeleteCaseReportModal,
  EditCaseReportModal,
} from "@/Features/CaseReports/Modals";

const CaseReportNameComponent = styled(({ className, rowData, color }) => {
  return (
    <div className={className}>
      <Link
        className={"item-link"}
        to={`generate-report/${rowData.case_report_id}`}
      >
        <div
          style={{
            display: "flex",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div>{!!rowData.name ? rowData.name : "View Report"}</div>
          <LaunchOutlinedIcon
            className="action-button"
            style={{ fontSize: 13, marginLeft: 5 }}
          />
        </div>
      </Link>
    </div>
  );
})`
  & {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  & .item-link {
    color: ${({ color, theme }) => color || theme.palette.primary.main};
    &:hover {
      text-decoration: underline;
    }
  }
`;

const ActionCell = ({ rowData }) => {
  const { hasPermission } = usePermissions();
  const { case_id } = useParams();

  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "left" }}>
        <DropdownMenu
          menuItems={[
            {
              label: "Edit",
              icon: EditIcon,
              onClick: () => setShowEditModel(true),
            },
            {
              label: "Delete",
              icon: TrashIcon,
              iconColor: "orangered",
              onClick: () => setShowDeleteModel(true),
            },
          ]}
          title={"Actions"}
          variant="outlined"
          // arrow
          disabled={!hasPermission()}
        >
          <MoreHorizOutlinedIcon style={{ fontSize: 13 }} />
        </DropdownMenu>
      </div>
      <EditCaseReportModal
        show={showEditModel}
        onClose={() => setShowEditModel(false)}
        caseId={case_id}
        defaultInfo={rowData}
      />
      <DeleteCaseReportModal
        show={showDeleteModel}
        onClose={() => setShowDeleteModel(false)}
        caseId={case_id}
        defaultInfo={rowData}
      />
    </>
  );
};

const CaseReportColumnDefs = [
  {
    dataField: "actions",
    caption: "",
    width: 55,
    allowSorting: false,
    allowReorder: false,
    showInColumnChooser: false,
    render: (rowData) => <ActionCell rowData={rowData} />,
  },
  {
    dataField: "name",
    caption: "Name",
    render: (rowData) => <CaseReportNameComponent rowData={rowData} />,
  },
  {
    dataField: "created_on",
    caption: "Created On",
    dataType: "date",
    format: {
      type: getDateFormat({
        isMoment: true,
        includeTime: false,
      }),
    },
  },
  {
    dataField: "created_by",
    caption: "Created By",
  },
  {
    dataField: "description",
    caption: "Description",
    titleRender: (rowData) => {
      return rowData.description;
    },
  },
];

export default CaseReportColumnDefs.slice();
